export function formatCostValue(value, fallback = '—') {
    const raw = value === null || value === undefined ? fallback : String(value).trim() || fallback;
    if (raw === fallback)
        return fallback;
    const numeric = Number(raw);
    return Number.isFinite(numeric) ? numeric.toFixed(2) : raw;
}
